//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/SelectBodyList.js";
import "../no/Expression.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/SelectObjectList.js";
let d=[[[0,"BodyCollector",1,"ScCollector",0],[1,"BodyToScale",0,"SelectBodyList",0],[0,"Csys",1,"CoordinateSystem",0],[0,"Point",1,"Point",0],[1,"ScaleAlongAxis",0,"Expression",0],[1,"ScaleOtherDirection",0,"Expression",0],[1,"ScaleXdirection",0,"Expression",0],[1,"ScaleYdirection",0,"Expression",0],[1,"ScaleZdirection",0,"Expression",0],[0,"Type",1,0],[1,"UniformFactor",0,"Expression",0],[0,"Vector",1,"Direction",0]],[],[]];
SPLM.Features.ScaleBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ScaleBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ScaleBuilder.Types = Object.freeze({
    "Uniform" : "Uniform", "Axisymmetric" : "Axisymmetric", "General" : "General"});

export default SPLM;